<template>
  <div class="web-check">
    <div class="title">
      <div class="title-inner">
        <div class="logo"></div>
        <div class="text">电子印章验签系统</div>
      </div>
    </div>

    <div v-show="!resultVisible" class="content">
      <div class="form">
        <div class="tip">
          <div>
            <!-- <i class="el-icon-info"></i> -->
            <span class="txt">欢迎使用本系统，请选择需要验证的文件</span>
          </div>
        </div>
        <div class="file">
          <!-- <span class="label">PDF文件</span> -->
          <div
            class="fileName"
            @mouseenter="closeVisible = true"
            @mouseleave="closeVisible = false"
          >
            <el-input
              v-model="name"
              :readonly="true"
              placeholder="请选择 PDF 文件"
              style="width: 240px"
              class="file-input"
            ></el-input>
            <span v-show="closeVisible" class="close" @click="resetSelect"
              >×</span
            >
          </div>

          <el-upload
            :auto-upload="false"
            :multiple="false"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :on-error="onError"
            :on-change="onChange"
            :on-exceed="onExceed"
            :file-list="fileList"
            :limit="1"
            ref="upload"
            :action="baseURL + '/seal/upload'"
            accept="application/pdf"
          >
            <el-button
              slot="trigger"
              type="primary"
              icon="el-icon-upload2"
              style="margin-left: 10px"
              >选择文件</el-button
            >
          </el-upload>
        </div>
        <div class="qrCode">
          <!-- <span class="label">验证码</span> -->
          <el-input
            v-model="qrCode"
            placeholder="验证码（不区分大小写）"
            style="width: 240px; margin-right: 10px"
            class="qr-input"
          ></el-input>
          <canvas width="117" height="40" id="captcha"></canvas>
          <!-- <span class="qrTip">不区分大小写</span> -->
        </div>
        <div class="btn">
          <el-button
            type="primary"
            size="medium"
            @click="check"
            style="width: 367px; height:40px"
            >验证文件
            <i class="el-icon-arrow-right el-icon--right"></i>
          </el-button>
        </div>
      </div>
    </div>

    <div v-show="resultVisible" class="result">
      <web-success :result="resultMsg"></web-success>
      <div class="close-wrapper">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { getQrCode, validateCode } from "@/api/check";
import WebSuccess from "@/components/WebSuccess";
import CaptchaMini from "captcha-mini";
export default {
  name: "WebCheck",

  components: {
    WebSuccess,
  },

  data() {
    return {
      name: "",
      qrCode: "",
      verifyCode: "",
      fileList: [],
      address: "",
      baseURL: process.env.VUE_APP_BASE_URL,
      resultMsg: {
        // isWreck: true,
        // concur: false,
        // fileName: "电子印章安全等级保护定级扫描（用印后）.pdf",
        // holder: "中宏人寿保险有限公司",
        // organization: "上海市数字证书认证中心有限公司",
        // modified: true,
        // signdate: "2022-05-10",
        // submitDate: "2022-01-01",
        // verified: true
      }, // 上传文件后返回的信息
      // success: false, // 上传文件是否校验通过
      resultVisible: false, // 是否显示结果
      closeVisible: false,
      isPdf: true
    };
  },

  mounted() {
    this.generateCaptcha();
  },

  methods: {
    // 如校验通过，则上传
    check() {
      console.log('check');
      const bool = this.validateBefore();
      if (bool) {
        this.loadingInstance = this.$loading({
          text: "上传中",
        });

        this.$refs.upload.submit();
      }
    },

    // 对文件是否上传、验证码进行校验
    validateBefore() {
      if (!this.name) {
        this.$message.warning("请上传文件");
        return false;
      }

      if (!this.qrCode) {
        this.$message.warning("请输入验证码");
        return false;
      }

      if (this.qrCode.toLowerCase() !== this.verifyCode.toLowerCase()) {
        this.$message.warning("验证码错误");
        return false;
      }
      
      if (!this.isPdf) {
        this.errorWindow('仅支持 PDF 文档验签')
        this.reset()
        return false
      }

      return true;

      // this.loadingInstance = this.$loading({
      //   text: "上传中",
      // });
      // 发请求校验验证码
      // const data = {
      //   code: this.qrCode,
      // };
      // const res = await validateCode(data).catch((err) => {
      //   console.log(err);
      //   this.$message.error("验证码校验失败");
      // });
      // if (res && res.data && res.data.success) {
      //   return true;
      // } else {
      //   this.$message.error(
      //     (res && res.data && res.data.message) || "验证码校验失败"
      //   );
      //   this.qrCode = "";
      //   this.loadingInstance && this.loadingInstance.close();
      //   this.getQrCodeApi();
      //   return false;
      // }
    },

    beforeUpload(file) {
      if(file.name.endsWith('.pdf')) {
        return true
      } else {
        return false
      }
    },

    // 上传成功
    onSuccess(res) {
      console.log("success");
      this.loadingInstance && this.loadingInstance.close();
      this.reset();
      if (res && res.data) {
        console.log(res.data);
        this.resultMsg = res.data;
        this.success =
          res.data.concur && res.data.verified && !res.data.modified;
        this.resultVisible = true;
      } else {
        this.errorWindow('数据异常')
      }
    },

    // 上传失败
    onError() {
      console.log("error");
      this.loadingInstance && this.loadingInstance.close();
      // this.$message.error("验证失败");
      this.errorWindow('验证失败')
      this.reset();
    },

    onChange(file) {
      if (file.status === "ready") {
        this.name = file.name;
        this.isPdf = file.name.endsWith('.pdf')
      }
    },

    // 上传数量超出一个
    onExceed() {
      console.log("文件数超了");
      // this.$message.error("只能同时验证1个文件");
      this.errorWindow('只能同时验证1个文件')
    },

    // 重置数据
    reset() {
      this.$refs.upload.clearFiles();
      this.name = "";
      this.qrCode = "";
      // this.getQrCodeApi();
      this.draw();
    },

    // 关闭结果显示
    close() {
      this.resultVisible = false;
      this.resultMsg = {};
    },

    // 生成验证码
    generateCaptcha() {
      this.captcha = new CaptchaMini({
        lineWidth: 1, //线条宽度
        lineNum: 2, //线条数量
        dotR: 2, //点的半径
        dotNum: 0, //点的数量
        preGroundColor: [10, 80], //前景色区间
        backGroundColor: [150, 250], //背景色区间
        fontSize: 20, //字体大小
        fontFamily: ["Georgia", "微软雅黑", "Helvetica", "Arial"], //字体类型
        fontStyle: "stroke", //字体绘制方法，有fill和stroke
        content: "1234567890abcdefghijklmnopqrstuvwxyz", //验证码内容
        length: 4, //验证码长度
      });
      this.draw();
    },

    // 绘制二维码
    draw() {
      this.captcha.draw(document.querySelector("#captcha"), (r) => {
        this.verifyCode = r;
        console.log("code", this.verifyCode);
      });
    },

    // 删除已选择的文件
    resetSelect() {
      this.name = "";
      this.fileList = [];
    },

    // 错误弹窗
    errorWindow(msg = '数据异常') {
      this.$message({
        type: 'error',
        iconClass: 'el-icon-warning',
        customClass: 'my-error',
        message: msg,
        duration: 3000,
        offset: 120
      })
    }
  },
};
</script>

<style scoped lang="scss">
.web-check {
  height: 100%;
  .title {
    height: 80px;
    padding-top: 8px;
    background-color: #fff;
    border-bottom: 6px solid #00a758;
    .title-inner {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1100px;
    }
    .logo {
      height: 60px;
      width: 230px;
      background: transparent url("~@/assets/images/logo-new.png") no-repeat center;
      background-size: 100% 100%;
    }
    .text {
      // margin-left: 30px;
      // padding-left: 30px;
      font-size: 25px;
      font-weight: bold;
      color: #666;
    }
  }
  .content {
    margin: 120px 0 0 0;
    .form {
      display: flex;
      flex-direction: column;
      width: 600px;
      margin: 0 auto;
      padding: 40px 24px;
      border: 2px solid #dcdfe6;
      // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      background: rgb(252, 252, 252);
      > .tip,
      .file,
      .qrCode,
      .btn {
        display: flex;
        justify-content: center;
      }
      .label {
        display: inline-block;
        vertical-align: middle;
        text-align: right;
        margin-right: 10px;
        width: 70px;
        font-size: 16px;
        font-weight: bold;
      }
      .tip {
        align-items: center;
        > div {
          width: 367px;
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          background: rgb(235, 242, 252);
          border: 1px solid rgb(138, 170, 255);
          border-radius: 3px;
          color: rgb(115, 117, 129);
          font-size: 14px;
          > i {
            color: #2d69ff;
          }
        }

        > span {
          display: inline-block;
          vertical-align: middle;
        }
        .alert {
          width: 27px;
          height: 27px;
          background: transparent url("~@/assets/images/alert.png") no-repeat
            center center;
          background-size: 100% 100%;
        }
        .txt {
          margin-left: 8px;
        }
      }
      .file {
        display: flex;
        align-items: center;
        margin-top: 40px;

        .fileName {
          position: relative;
          .file-input {
            /deep/ input {
              padding-right: 25px;
            }
          }
          .close {
            display: inline-block;
            text-align: center;
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-8px);
            width: 16px;
            height: 16px;
            line-height: 14px;
            border-radius: 50%;
            border: 1px solid #666;
            color: #666;
            cursor: pointer;
          }
        }
      }
      .qrCode {
        display: flex;
        align-items: center;
        margin-top: 30px;
        .qrTip {
          display: inline-block;
          vertical-align: bottom;
          margin-left: 14px;
          font-size: 13px;
        }
        > img {
          height: 40px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .btn {
        margin-top: 30px;
      }
    }
  }
  .result {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .close-wrapper {
      display: flex;
      justify-content: center;
      padding-top: 30px;
    }
  }
}
</style>